// src/App.jsx
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import FacebookDataDeletion from "./pages/FacebookDataDeletion";
import ForgetPassword from "./pages/ForgetPassword";
import Home from "./pages/Home";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Profile from "./pages/Profile";
import Registration from "./pages/Registration";
import TermsConditions from "./pages/TermsConditions";
import FinalConfirmation from "./pages/unsubscription/FinalConfirmation";
import NegativeImpact from "./pages/unsubscription/NegativeImpact";
import SubscriptionList from "./pages/unsubscription/SubscriptionList";

import AlertPage from "./pages/AlertPage";
import HomePage from "./pages/HomePage";
import HomeV2 from "./pages/HomeV2";
import ProfileEdit from "./pages/ProfileEdit";
import Welcome from "./pages/Welcome";

import Leftbar from "./components/Leftbar";
import Chat from "./pages/Chat";
// import Dashboard from "./pages/Dashboard";

import { SocketProvider } from "./service/SocketProvider";

import { Provider } from "react-redux";
import "./App.css";
import Alerts from "./pages/Alerts/Alerts";
import Chats from "./pages/Chats";
import CourseDetails from "./pages/CourseDetails";
import CoursePage from "./pages/CoursePage";
import Payment from "./pages/Payment";
import MarketData from "./pages/MarketData";
import NewsPage from "./pages/NewsPage";
import PersonalChat from "./pages/PersonalChat";
import PersonalChats from "./pages/PersonalChats";
import store from "./redux/store";

const App = () => {
  return (
    <Provider store={store}>
      <SocketProvider>
        <Router>
          <Routes>
            <Route element={<Navbar />}>
              <Route path="/old" element={<HomePage />} />
              <Route path="/v2" element={<HomeV2 />} />
              <Route path="/welcome" element={<Welcome />} />

              <Route path="/" element={<Home />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsConditions />} />
              <Route
                path="/data-deletion"
                element={<FacebookDataDeletion />}
              />
              <Route path="/alerts" element={<AlertPage />} />

              <Route path="/*" element={<NotFound />} />
            </Route>

            <Route path="/signin" element={<Login />} />
            <Route path="/signup" element={<Registration />} />
            <Route path="/forget-password" element={<ForgetPassword />} />

            <Route element={<Leftbar />}>
              <Route path="/dashboard" element={<NewsPage />} />

              {/* <Route path="/news" element={<NewsPage />} /> */}

              <Route path="/personal-chat" element={<PersonalChats />} >
                <Route path="/personal-chat/:id" element={<PersonalChat />} />
              </Route>

              <Route path="/chat" element={<Chats />} >
                <Route path="/chat/:id" element={<Chat />} />
              </Route>

              <Route path="/market-data" element={<MarketData />} />

              <Route path="/courses" element={<CoursePage />} />
              <Route path="/course/:courseId" element={<CourseDetails />} />
              <Route path="/payment" element={<Payment />} />

              <Route path="/site-alerts" element={<Alerts />} />

              <Route path="/profile" element={<Profile />} />
              <Route path="/profile/edit" element={<ProfileEdit />} />

              <Route path="/unsubscribe/:id" element={<SubscriptionList />} />
              <Route path="/unsubscribe/:id/impact" element={<NegativeImpact />} />
              <Route
                path="/unsubscribe/:id/confirm"
                element={<FinalConfirmation />}
              />
            </Route>
          </Routes>
        </Router>
      </SocketProvider>
    </Provider>
  );
};

export default App;
